<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCourse" isAdd class="ml-2" :to="{ name: 'CreateCourse' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getCourseData()"
      actionViewRouteLink="CourseDetails"
      @delete-clicked="handleDelete($event)"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'CourseList',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'grade', text: vm.$t('grade'), width: 150 },
        { value: 'course_category', text: vm.$t('courseCategory'), width: 150 },
        { value: 'center_name', text: vm.$t('campus'), width: 500 },
      ]
      if (this.$validate.allowAction('CourseDetails', this.userType)) {
        headers.push({ value: 'actionViewAndDelete', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateCourse', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getCourseData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
          join_school_data: true,
          join_category_data: true,
        }

        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          payload['center_id'] = selectedSchool
        }

        const { data, total } = await this.$Fetcher.GetCourses(payload)
        this.tableData = data.map(el => {
          return {
            id: el.id,
            grade: el.grade,
            name: el.name,
            course_category: this.$validate.DataValid(el.category_data) ? el.category_data.name : '',
            center_name: this.$t(el.center_name),
          }
        })

        this.tableItemTotal = total
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    // -- (刪除)
    async handleDelete(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteCourse(id, true)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.tableFilter.page = 1
          this.getCourseData()
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: CourseList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getCourseData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
